import Connection from 'utils/connection';
import { GET_LANDING_PAGES, GET_LINK_SHORTENER, GET_MARKETING_SOURCES_NAMES } from 'constants/api';

const getMarketingSourcesNames = () => {
  return Connection.post(GET_MARKETING_SOURCES_NAMES);
};

const getDomains = async ({ state, effects }) => {
  state.domains = (await effects.tools.getDomains()).result;
};

const getLandingPages = () => {
  return Connection.get(GET_LANDING_PAGES);
};

const createShortLink = ({ effects }, { data, linkShortenerUrl }) => {
  return effects.tools.createShortLink(linkShortenerUrl.concat(GET_LINK_SHORTENER), data);
};

export { getDomains, createShortLink, getLandingPages, getMarketingSourcesNames };
